<template>
    <div>
        <div class="flex-between">
            <span></span>
            <div class="input_box">
                <input type="text" v-model="queryData.query" @keyup.enter="listByPageLogFun" placeholder="请输入关键字检索" />
                 <span style="cursor: pointer" @click="listByPageLogFun"><i class="el-icon-search"></i></span>
            </div>
        </div>
        <div>
            <el-table
                :header-cell-style="{
					background: 'rgba(229,244,255,1)',
					color: '#0077CC',
					fontWeight: 'bold'
				}"
                align="center"
                header-align="center"
                :data="tableData"
                style="width: 100%"
            >
                <el-table-column type="index" label="序号" header-align="center" align="center"></el-table-column>
                <el-table-column prop="operaName" label="操作类型" header-align="center" align="center"></el-table-column>
                <el-table-column prop="operaDesc" label="操作内容" header-align="center" width="280" align="center">
                    <template slot-scope="scope"><p class="line-clamp2" :title="scope.row.operaDesc">{{scope.row.operaDesc}}</p></template>
                </el-table-column>
                <el-table-column prop="userName" label="操作人" header-align="center" align="center"></el-table-column>
                <el-table-column prop="createDt" label="创建时间" header-align="center" align="center">
                    
                    <template slot-scope="scope">{{scope.row.createDt | timestampToTime}}</template>
                </el-table-column>
                <el-table-column prop="ipaddress" label="IP" header-align="center" align="center"></el-table-column>
                
                
            </el-table>
        </div>
        <div class="flex-end">
            当前 第 {{queryData.currentPage}} 页，共 {{queryData.pages}} 页 {{queryData.total}} 条记录
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="queryData.currentPage"
                :page-size="queryData.pageSize"
                layout="prev, pager, next, jumper"
                :total="queryData.total"
                style="padding: 45px; text-align:right;"
            ></el-pagination>
        </div>

    </div>
</template>

<script>
import {
    listByPageLog,//列表查询

    // editPassword
} from "../../../api/system.js";
export default {
    name: "breadcrumbList",
    filters:{
        timestampToTime(timestamp) {
            let date = new Date(timestamp);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
            if(!timestamp){
                return '';
            }
            let Y = date.getFullYear() + '-';
            let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
            let D = date.getDate() + ' ';
            let h = date.getHours() + ':';
            let m = date.getMinutes() + ':';
            let s = date.getSeconds();
            return Y + M + D + h + m + s;
        }
    },
    data() {
        return {
            search: "",
            tableData: [
                
            ],
            dialogVisible: false,
            content: "",
            
            queryData: {
                currentPage: 1, //当前页
                pageSize: 10,
                total: 0,
                query: "", //模糊搜索
                pages: "" //共多少页
            }
        };
    },
    methods: {
        handleClose(done) {
            this.$refs['ruleForm'].resetFields();
            this.dialogVisible = false
        },
        handleSizeChange(val) {
              this.queryData.pageSize = val;
              this.listByPageFun();
            //console.log(`每页 ${val} 条`);
        },
        handleCurrentChange(val) {
            //console.log(val);
              this.queryData.currentPage = val;
            //console.log(this.queryData);
            this.listByPageLogFun()
            //console.log(`当前页: ${val}`);
        },
        //列表
        listByPageLogFun() {
            listByPageLog({
                currentPage: this.queryData.currentPage,
                pageSize: this.queryData.pageSize,
                query: this.queryData.query
            })
                .then(res => {
                    //console.log(res, "日志列表==成功");
                    if (res.code == 200) {
                        this.tableData = res.data.list || [];
                        this.queryData.total = res.data.total || 0;
                        this.queryData.pages = res.data.pages || 0;
                        //console.log(this.queryData, "this.queryData");
                    }else{
                        this.$message.error(res.message);
                    }
                })
                .catch(err => {
                    //console.log(err, "日志列表==失败");
                });
        }
    },
    mounted() {},
    created() {
        this.listByPageLogFun();
    },
    computed: {
        // editor() {
        //     return this.$refs.myQuillEditor.quill;
        // }
    }
};
</script>

<style lang="less" scoped>
.el-table {
    margin-top: 20px;
    /deep/ th .cell {
        font-weight: bold;
    }
    .el-button--text {
        color: #197cda;
    }
    .ql-editor {
        min-height: 150px;
    }
}
.flex-between {
    display: flex;
    justify-content: space-between;
}
.primary {
    width: 80px;
    height: 30px;
    background: rgba(0, 145, 255, 1);
    box-shadow: 0px 1px 3px 0px rgba(0, 72, 128, 0.3);
    border-radius: 4px;
    padding: 0;
}
.input_box {
    width: 300px;
    height: 36px;
    border: 1px solid rgba(153, 194, 255, 1);
    border-radius: 4px;
    input {
        width: 270px;
        height: 36px;
        line-height: 36px;
        font-style: italic;
        color: rgba(153, 153, 153, 1);
        font-size: 14px;
        box-sizing: border-box;
        padding-left: 10px;
    }
}
.flex-end {
    display: flex;
    justify-content: flex-end;
    color: #999999;
    font-size: 14px;
    align-items: center;
    margin-top: 30px;
}
</style>
